import { render, staticRenderFns } from "./ChangeLiquidationValue.vue?vue&type=template&id=7bb2c398&"
import script from "./ChangeLiquidationValue.vue?vue&type=script&lang=js&"
export * from "./ChangeLiquidationValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports